/* so-dates — the store's ONE date engine: SAST dispatch day, business days, public holidays and the
   pre-order ship window. Pure; no DOM (except readConfig). Loaded `defer` in <head> (layout/theme.liquid)
   so it runs before every other deferred script. Used by so-stock-state.js; the postcode rebuild's
   so-postcode.js carries the same functions (extracted from it, 2026-09-27) and should switch to
   SO.dates when it goes live. All SAST (UTC+2, no DST) wall time without a timezone library: a "dayMs"
   is the UTC-midnight ms of the SAST calendar day. Copy rule: "today" or the weekday, never "tomorrow". */
(function (root, factory) {
  var api = factory();
  if (typeof window === 'undefined' && typeof module === 'object' && module.exports) module.exports = api;
  else { root.SO = root.SO || {}; root.SO.dates = api; }
})(typeof self !== 'undefined' ? self : this, function () {
  var DAY = 864e5, SAST = 2 * 3600 * 1000;
  var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  // "7 AM" | "7:30 AM" | "1 PM" | "13:00" | 7 → minutes after midnight; null when unreadable.
  function parseCutoff(v) {
    if (typeof v === 'number') return v >= 0 && v < 24 ? Math.round(v * 60) : null;
    var m = String(v == null ? '' : v).trim().match(/^(\d{1,2})(?:[:h.](\d{2}))?\s*(am|pm)?$/i);
    if (!m) return null;
    var h = +m[1], mi = m[2] ? +m[2] : 0, ap = (m[3] || '').toLowerCase();
    if (ap) { if (h < 1 || h > 12) return null; if (ap === 'pm' && h !== 12) h += 12; if (ap === 'am' && h === 12) h = 0; }
    return h > 23 || mi > 59 ? null : h * 60 + mi;
  }
  function cutMin(cfg) {
    if (cfg && typeof cfg.cutoffMin === 'number') return cfg.cutoffMin;
    if (cfg && typeof cfg.cutoffHour === 'number') return cfg.cutoffHour * 60;
    return null;
  }
  function sastParts(nowMs) {
    var d = new Date(nowMs + SAST);
    return { y: d.getUTCFullYear(), m: d.getUTCMonth(), day: d.getUTCDate(), dow: d.getUTCDay(), h: d.getUTCHours(), min: d.getUTCMinutes() };
  }
  function todayOf(nowMs) { var p = sastParts(nowMs); return Date.UTC(p.y, p.m, p.day); }
  function isoDay(t) { return new Date(t).toISOString().slice(0, 10); }
  function isBusinessDay(t, hol) { var w = new Date(t).getUTCDay(); return w !== 0 && w !== 6 && (hol || []).indexOf(isoDay(t)) < 0; }
  function addBusinessDays(t, n, hol) { var x = t; while (n > 0) { x += DAY; if (isBusinessDay(x, hol)) n--; } return x; }
  function dispatchDay(nowMs, cfg) {
    var p = sastParts(nowMs), today = Date.UTC(p.y, p.m, p.day), c = cutMin(cfg);
    if (c != null && isBusinessDay(today, cfg.holidays) && p.h * 60 + p.min < c) return today;
    var x = today + DAY; while (!isBusinessDay(x, cfg && cfg.holidays)) x += DAY; return x;
  }
  // No holiday list for that year → we can't promise a date (callers use plain wording).
  function holidaysCover(t, cfg) {
    var y = String(new Date(t).getUTCFullYear());
    return ((cfg && cfg.holidays) || []).some(function (h) { return String(h).slice(0, 4) === y; });
  }
  // "5–10 business days" → [5, 10]; null for anything else ("2–3 weeks", "soon", "").
  function leadDays(v) {
    var a, b;
    if (Array.isArray(v)) { a = v[0]; b = v[1]; }
    else {
      var m = String(v == null ? '' : v).match(/(\d{1,3})\s*(?:[–—-]|to)\s*(\d{1,3})\s*(?:business|working)\s+days?\b/i);
      if (!m) return null;
      a = +m[1]; b = +m[2];
    }
    return typeof a === 'number' && typeof b === 'number' && a % 1 === 0 && b % 1 === 0 && a >= 0 && b >= a && b <= 120 ? [a, b] : null;
  }
  function fmtDay(t) { var d = new Date(t); return DOW[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MON[d.getUTCMonth()]; }
  function fmtRange(a, b) {
    if (a === b) return fmtDay(a);
    var da = new Date(a), db = new Date(b);
    return da.getUTCMonth() === db.getUTCMonth() ? DOW[da.getUTCDay()] + ' ' + da.getUTCDate() + ' – ' + fmtDay(b) : fmtDay(a) + ' – ' + fmtDay(b);
  }
  // Compact form (no weekday), used for rows/pills/FBT/cart gate: "12 Oct" | "5 – 12 Oct" | "30 Sep – 6 Oct".
  function fmtRangeShort(a, b) {
    if (a === b) { var d = new Date(a); return d.getUTCDate() + ' ' + MON[d.getUTCMonth()]; }
    var da = new Date(a), db = new Date(b);
    if (da.getUTCMonth() === db.getUTCMonth()) return da.getUTCDate() + ' – ' + db.getUTCDate() + ' ' + MON[db.getUTCMonth()];
    return da.getUTCDate() + ' ' + MON[da.getUTCMonth()] + ' – ' + db.getUTCDate() + ' ' + MON[db.getUTCMonth()];
  }
  function preorderWindow(cfg, nowMs) {
    var r = cfg ? leadDays(cfg.preorderDays != null ? cfg.preorderDays : cfg.preorderLeadTime) : null;
    if (!r || !(nowMs >= 0)) return null;
    var d = dispatchDay(nowMs, cfg), from = addBusinessDays(d, r[0], cfg.holidays), to = addBusinessDays(d, r[1], cfg.holidays);
    if (!holidaysCover(d, cfg) || !holidaysCover(to, cfg)) return null;
    return { from: from, to: to, text: fmtRange(from, to) };
  }
  // full = true → "Tuesday" (stock lines, Charl 2026-09-28); dates and ranges keep the short "Tue".
  var DOW_FULL = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  function dayWord(t, today, full) { return t === today ? 'today' : (full ? DOW_FULL : DOW)[new Date(t).getUTCDay()]; }
  // The next moment a day-aware line can change: today's cut-off (if ahead) or the coming SAST midnight.
  function nextBoundary(nowMs, cfg) {
    var p = sastParts(nowMs), mid = Date.UTC(p.y, p.m, p.day) - SAST, c = cutMin(cfg), cut = mid + (c > 0 ? c : 0) * 6e4;
    return nowMs < cut ? cut : mid + DAY;
  }
  var cached;
  function readConfig(doc) {
    if (cached !== undefined) return cached;
    cached = null;
    try {
      var el = (doc || document).querySelector('script[data-so-dates-config]');
      var c = el ? JSON.parse(el.textContent) : null;
      if (c) {
        c.cutoffMin = parseCutoff(c.cutoff);
        c.cutoffHour = c.cutoffMin == null ? null : Math.floor(c.cutoffMin / 60);
        c.preorderDays = leadDays(c.preorderLeadTime);
        c.lowAt = Number(c.lowAt) > 0 ? Number(c.lowAt) : 9;
        cached = c;
      }
    } catch (e) { cached = null; }
    return cached;
  }
  return { parseCutoff: parseCutoff, sastParts: sastParts, todayOf: todayOf, isBusinessDay: isBusinessDay, addBusinessDays: addBusinessDays,
           dispatchDay: dispatchDay, holidaysCover: holidaysCover, leadDays: leadDays, preorderWindow: preorderWindow,
           fmtDay: fmtDay, fmtRange: fmtRange, fmtRangeShort: fmtRangeShort, dayWord: dayWord, nextBoundary: nextBoundary, readConfig: readConfig };
});
